import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Loader from "@/components/Loader";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <Loader label="Checking your session…" />;

  if (!user) {
    localStorage.setItem("postLoginRedirect", location.pathname + location.search);
    return <Navigate to="/login" replace />;
  }

  return children;
}
